import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ConfigState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ConfigQuery extends QueryEntity<ConfigState> {

  constructor(protected store: Store) {
    super(store);
  }

}
